import { useEffect } from "react";
import { isMobileDevice } from "../utils/device";

const useVConsole = () => {
  useEffect(() => {
    // 仅在测试环境且手机端执行
    if (
      process.env.NEXT_PUBLIC_REGION === "CN-TEST" &&
      typeof window !== "undefined" &&
      isMobileDevice()
    ) {
      import("vconsole").then((module) => {
        const VConsole = module.default;
        new VConsole();
      });
    }
  }, []);
};

export default useVConsole;
